module.exports = __webpack_public_path__ + "img/noLearn.2324280d.png";